export const FILTER_BAR_FILTER_TRIGGER_VARIANT = {
  COMPACT_ICON: 'compactIcon',
  DEFAULT: 'default',
}

export const QA_NAME_FILTERS_BTN = 'filter'

export const QA_NAME_FILTERS_COMPACT_CLEAR_BTN = 'filter-compact-clear'

export const RATING_OPTIONS = [
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
  { value: 5 },
]

export const FILTER_TEMPLATE_DROPDOWN_MAX_WIDTH = 354
